// 文件与附件：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 文件预览
export const preview = Object.freeze({
  "filePreview.dialog": "檔案預覽",
  "filePreview.interactionMode": "預覽交互模式",
  "filePreview.contentModeHint": "{mode}模式下可使用檔案自身的預覽功能",
  "filePreview.globalDragHint": "在內容區域按住滑鼠可拖動整個預覽窗口",
  "filePreview.globalDrag": "全局拖拽",
  "filePreview.close": "關閉檔案預覽",
  "filePreview.previous": "上一個檔案",
  "filePreview.next": "下一個檔案",
  "filePreview.loading": "檔案載入中...",
  "filePreview.pdfLoading": "PDF 載入中...",
  "filePreview.pdfLoadFailed": "PDF 暫時無法預覽，請重試或下載檔案",
  "filePreview.retry": "重試",
  "filePreview.downloadFile": "下載檔案",
  "filePreview.zoomOutPdf": "縮小 PDF",
  "filePreview.zoomInPdf": "放大 PDF",
  "filePreview.videoLoading": "影片載入中...",
  "filePreview.videoUnsupported": "當前瀏覽器不支持該影片格式或編碼",
  "filePreview.downloadVideo": "下載影片",
  "filePreview.openNewWindow": "新窗口打開",
  "filePreview.loadFailed": "檔案載入失敗，請關閉後重試",
  "filePreview.dragToMove": "拖動以移動預覽窗口",
  "filePreview.videoToolbar": "影片預覽工具",
  "filePreview.imageToolbar": "圖片預覽工具",
  "filePreview.rotateLeft": "向左旋轉",
  "filePreview.rotateRight": "向右旋轉",
  "filePreview.zoomOutVideo": "縮小影片",
  "filePreview.zoomOutImage": "縮小圖片",
  "filePreview.resetVideo": "復位影片",
  "filePreview.resetImage": "復位圖片",
  "filePreview.zoomInVideo": "放大影片",
  "filePreview.zoomInImage": "放大圖片",
  "filePreview.unknownFile": "未知檔案",
  "filePreview.imageMode": "圖片操作",
  "filePreview.videoMode": "影片操作",
  "filePreview.documentMode": "文檔操作",
  "filePreview.noFile": "暫無可預覽檔案",
  "filePreview.addressFailed": "檔案訪問地址獲取失敗",
});

// 文件库
export const library = Object.freeze({
  "uploadLibrary.associationAll": "全部",
  "uploadLibrary.associationLinked": "已關聯",
  "uploadLibrary.associationUnlinked": "未關聯",
  "uploadLibrary.allFiles": "全部檔案",
  "uploadLibrary.recent": "最近使用",
  "uploadLibrary.ungrouped": "未分組",
  "uploadLibrary.images": "圖片",
  "uploadLibrary.videos": "影片",
  "uploadLibrary.documents": "檔案",
  "uploadLibrary.previewUnavailable": "當前檔案暫無可用預覽地址",
  "uploadLibrary.typeNotAllowed": "該檔案類型不符合當前上傳要求",
  "uploadLibrary.sizeExceeded": "該檔案大小超過當前上傳限制",
  "uploadLibrary.enterGroupName": "請輸入分組名稱",
  "uploadLibrary.newGroup": "新建分組",
  "uploadLibrary.groupNameRequired": "分組名稱不能為空",
  "uploadLibrary.groupCreated": "分組已創建",
  "uploadLibrary.deleteGroupConfirm":
    "刪除分組“{name}”後，組內檔案將移到未分組，檔案不會被刪除。是否繼續？",
  "uploadLibrary.deleteGroup": "刪除分組",
  "uploadLibrary.groupDeleted": "分組已刪除，組內檔案已移到未分組",
  "uploadLibrary.chooseFile": "請選擇要上傳的檔案",
  "uploadLibrary.unsupportedType": "{name}：不支持該檔案類型",
  "uploadLibrary.maxFileSize": "{name}：檔案大小不能超過{size}MB",
  "uploadLibrary.fileUploadFailed": "{name}：上傳失敗",
  "uploadLibrary.missingFileRecord": "{name}：後端未返回真實檔案記錄",
  "uploadLibrary.uploadFailed": "上傳失敗",
  "uploadLibrary.uploadSuccess":
    "成功上傳{count}個檔案，已切換到全部檔案並自動選中",
  "uploadLibrary.uploadFailedCount": "{count}個檔案上傳失敗：{reason}",
  "uploadLibrary.filesMoved": "已將{count}個檔案移動到“{name}”",
  "uploadLibrary.deleteFilesConfirm":
    "確認刪除選中的{count}個未關聯檔案？已關聯的檔案不可刪除！",
  "uploadLibrary.deleteFiles": "批量刪除檔案",
  "uploadLibrary.deleteSummary": "已刪除{deleted}個檔案，跳過{skipped}個檔案",
  "uploadLibrary.refreshAndRetry": "請刷新頁面後重試",
  "uploadLibrary.deleteFailedReason": "{message}；{reason}",
  "uploadLibrary.deleteSkippedReason": "{message}。未刪除原因：{reason}",
  "uploadLibrary.selectionLimit": "當前上傳入口最多選擇{count}個檔案",
  "uploadLibrary.privateFileNotAllowed":
    "該私有檔案無法用於當前公開業務，請選擇有權限的檔案",
  "uploadLibrary.selectionUnavailable":
    "部分檔案無選用權限或已失效，請重新選擇本人檔案",
  "uploadLibrary.selectFile": "選擇檔案",
  "uploadLibrary.selectType": "選擇{type}",
  "uploadLibrary.filter": "篩選",
  "uploadLibrary.searchAllGroupFiles": "搜索所有分組中的檔案名稱",
  "uploadLibrary.searchFileNames": "全局搜索檔案名稱",
  "uploadLibrary.search": "搜索",
  "uploadLibrary.localBulkUpload": "本地批量上傳",
  "uploadLibrary.localUpload": "本地上傳",
  "uploadLibrary.maxImagesPerGroup": "每組最多100張",
  "uploadLibrary.selectPage": "全選本頁",
  "uploadLibrary.batchManage": "批量管理",
  "uploadLibrary.group": "分組",
  "uploadLibrary.delete": "刪除",
  "uploadLibrary.selectedPrefix": "已選擇",
  "uploadLibrary.selectedNoticeTail": "個檔案，可確認選擇或進行批量管理",
  "uploadLibrary.selectedFilesTail": "個檔案",
  "uploadLibrary.selectFilesHint": "請勾選檔案，選中後可確認選擇或進行批量管理",
  "uploadLibrary.clearSelection": "清空選擇",
  "uploadLibrary.deletionProgress":
    "正在處理 {processed}/{total}，已刪除 {deleted}，跳過 {skipped}",
  "uploadLibrary.selectNamedFile": "選擇檔案：{name}",
  "uploadLibrary.previewImage": "預覽圖片",
  "uploadLibrary.previewVideo": "預覽影片",
  "uploadLibrary.previewFile": "預覽檔案",
  "uploadLibrary.preview": "預覽",
  "uploadLibrary.noRecentFilesPc": "暫無最近使用檔案，請先新建或選擇分組",
  "uploadLibrary.noRecentFilesMobile":
    "暫無最近使用檔案，可到全部檔案中選擇或上傳",
  "uploadLibrary.noMatchingFiles": "暫無符合條件的檔案",
  "uploadLibrary.noFiles": "暫無檔案",
  "uploadLibrary.batchGroup": "批量分組",
  "uploadLibrary.selectTargetGroupTail": "個檔案，請選擇目標分組",
  "uploadLibrary.searchGroups": "搜索分組名稱",
  "uploadLibrary.targetGroup": "目標分組",
  "uploadLibrary.noMatchingGroups": "沒有匹配的分組，可修改關鍵詞或新建分組",
  "uploadLibrary.noGroups": "暫無分組，點擊上方新建分組",
  "uploadLibrary.groupChangeImmediate": "分組變更儲存後會立即生效。",
  "uploadLibrary.cancel": "取消",
  "uploadLibrary.confirm": "確定",
  "uploadLibrary.confirmSelection": "確認選擇",
  "uploadLibrary.confirmSelectionCount": "確認選擇（{count}）",
  "uploadLibrary.filePagination": "檔案分頁",
  "uploadLibrary.totalFiles": "共 {count} 條",
  "uploadLibrary.previousPage": "上一頁",
  "uploadLibrary.nextPage": "下一頁",
  "uploadLibrary.filterFiles": "篩選檔案",
  "uploadLibrary.fileGroups": "檔案分組",
  "uploadLibrary.deleteNamedGroup": "刪除分組：{name}",
  "uploadLibrary.associationStatus": "關聯狀態",
  "uploadLibrary.reset": "重置",
  "uploadLibrary.selectFilePrompt": "請選擇檔案",
});

// 缩略图
export const thumbnail = Object.freeze({
  "uploadThumbnail.pdfCover": "PDF 第一頁封面",
  "uploadThumbnail.textSummary": "檔案內容摘要",
  "uploadThumbnail.loading": "正在載入封面",
  "uploadThumbnail.unavailable": "暫時無法顯示封面",
  "uploadThumbnail.formatCover": "格式封面",
  "uploadThumbnail.firstPage": "第 1 頁",
  "uploadThumbnail.summary": "內容摘要",
  "uploadThumbnail.videoCover": "影片封面",
  "uploadThumbnail.videoFailed": "無法產生影片封面",
  "uploadThumbnail.videoLoading": "正在載入影片封面",
  "uploadThumbnail.groupName": "分組名稱",
  "uploadThumbnail.deleteCount": "刪除 {count} 個檔案？",
  "uploadThumbnail.irreversible": "刪除後無法還原。",
  "uploadThumbnail.skipCount": "另有 {count} 個已關聯或狀態不明的檔案將略過。",
});

export const attachmentUi = Object.freeze({
  "attachmentUi.maxFiles": "最多只能上傳{count}個檔案",
  "attachmentUi.fileSizeLimit": "{name} 超過大小限制（最大{size}MB）",
  "attachmentUi.unsupportedFile": "不支援的檔案類型：{name}",
  "attachmentUi.remainingFiles":
    "最多只能上傳{count}個檔案，還可上傳{remaining}個",
  "attachmentUi.fileRejectionReason": "駁回原因：{reason}",
  "attachmentUi.originalTemplateHint": "上傳合同原始範本",
  "attachmentUi.singleStampedHint": "上傳單方蓋章版本",
  "attachmentUi.doubleStampedHint": "上傳雙方蓋章版本",
  "attachmentUi.tradeContractFiles": "交易合同檔案",
  "attachmentUi.piFiles": "PI檔案",
  "attachmentUi.ciFiles": "CI檔案",
  "attachmentUi.templateContractFiles": "範本合同檔案",
  "attachmentUi.singleStampedFiles": "單章合同檔案",
  "attachmentUi.doubleStampedFiles": "雙章合同檔案",
  "attachmentUi.viewNamedFile": "查看{name}",
  "attachmentUi.uploadNamedFile": "上傳{name}",
  "attachmentUi.deleteNamedItem": "刪除{name}",
  "attachmentUi.rejectedPrefix": "已駁回：",
  "attachmentUi.documents": "文件清單",
  "attachmentUi.rejectionHint": "已駁回，點擊查看駁回原因",
  "attachmentUi.viewReason": "查看原因",
  "attachmentUi.upload": "上傳",
  "attachmentUi.stamp": "印章",
  "attachmentUi.noRejectionReason": "暫無駁回原因",
  "attachmentUi.removeAttachment": "移除附件",
  "attachmentUi.fileTooLarge": "{name} 超過10MB，無法上傳",
  "attachmentUi.fileUploaded": "{name} 上傳成功",
  "attachmentUi.downloadFailed": "{name}下載失敗",
});

export const sharedFlowUi = Object.freeze({
  "attachmentUi.uploadFailed": "附件上傳失敗",
});

export const messages = Object.freeze({
  ...sharedFlowUi,
  ...attachmentUi,
  ...preview,
  ...library,
  ...thumbnail,
});
